import { isJobInProgress } from "./jobHelpers";

const REPORT_JOB_NAME = "generate_class_report";

export const isReportJobPending = job =>
  Boolean(job && job.name === REPORT_JOB_NAME && isJobInProgress(job));

export const findPendingReportJob = (jobs, reportId) => {
  if (reportId == null) return null;
  return (jobs || []).find(
    job =>
      isReportJobPending(job) && String(job.reportId) === String(reportId)
  );
};

/**
 * Remove entradas locais quando o job correspondente termina ou some da fila.
 * Mantém "submitting" e jobIds ainda não refletidos na fila.
 */
export const pruneGeneratingByReportId = (
  generatingByReportId,
  jobs,
  previousJobs = []
) => {
  if (!generatingByReportId || !Object.keys(generatingByReportId).length) {
    return generatingByReportId;
  }

  let changed = false;
  const next = { ...generatingByReportId };

  Object.keys(next).forEach(reportId => {
    const token = next[reportId];
    if (token === "submitting") return;

    const job = (jobs || []).find(item => item.id === token);
    if (job) {
      if (!isJobInProgress(job)) {
        delete next[reportId];
        changed = true;
      }
      return;
    }

    const wasInPrevious = (previousJobs || []).some(item => item.id === token);
    if (wasInPrevious) {
      delete next[reportId];
      changed = true;
    }
  });

  return changed ? next : generatingByReportId;
};

export const isReportGenerating = (reportId, generatingByReportId, jobs) => {
  if (reportId == null) return false;
  if (
    generatingByReportId &&
    (generatingByReportId[reportId] != null ||
      generatingByReportId[String(reportId)] != null)
  ) {
    return true;
  }
  return Boolean(findPendingReportJob(jobs, reportId));
};
